/*  ----------------------------------
 /   Filter and positioning on a grid
 /   Use jQuery and Isotope libraries
 ---------------------------------*/

;(function initGrid($) {

    $(window).ready(init);

    var CONTAINER = '.js-Grid';
    var LIST = '.js-Grid-list';
    var ITEM = '.js-Grid-item';

    var OPTIONS = {
        itemSelector: ITEM,
        percentPosition: true,
        masonry: {
            // use element to figure out width
            columnWidth: '.js-Grid-sizer'
        },
        getSortData: {
            id: '[data-id]',
            pin: '[data-pin]'
        },
        sortBy: ['pin', 'id']
    };

    function init() {
        var container = $(CONTAINER);
        var list = $(LIST);

        if (container.length > 0) {
            // Init Isotope
            list.isotope(OPTIONS);
        }
    }

})(jQuery);
